import React, { FC, ReactElement, useContext } from 'react'
import { useFormContext, UseFormMethods } from '../../../Vendor/react-hook-form/dist/index.ie11'
import { ConfigureAgents } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import ModalExitPromptContext, { ModalExitPromptType } from '../../Common/Components/Modal/ModalExitPromptContext'
import { DocTopic } from '../../Common/Constants/Documentation'
import { LanguageContext } from '../../Common/Contexts'
import { CommonFormContext, FormContextType } from '../../Common/Contexts/CommonFormContext'
import { ModalContext, ModalContextType } from '../../Common/Contexts/ModalContext'
import { openHelpPortalByTopic } from '../../Common/Utils'
import { servletPath } from '../../../NonReact/common/RxJS/RxJS'
import { RoundedButton } from '../../../ReactRouting/Components/Atoms/RoundedButton/RoundedButton'

export const FooterActions: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    const { displayExitPrompt }: ModalExitPromptType = useContext(ModalExitPromptContext)
    const commonForm: Nullable<FormContextType> = useContext(CommonFormContext)
    const { closeModal }: ModalContextType = useContext(ModalContext)
    const {
        formState: { isValid }
    }: UseFormMethods = useFormContext()

    const handleHelpClick = (): void => {
        openHelpPortalByTopic(servletPath, DocTopic.ADMINACDAGENTSADD)
    }

    const handleCancel = (): void => {
        if (commonForm?.isTouched) {
            displayExitPrompt()
        } else {
            closeModal()
        }
    }

    return (
        <div className='ca-footer-actions'>
            <div className='tabs-footer'>
                <RoundedButton type='button' onClick={handleHelpClick} shrink>
                    {language.get(ConfigureAgents.ConfigureAgents_Footer_Help)}
                </RoundedButton>
                <RoundedButton type='submit' disabled={!isValid} shrink>
                    {language.get(ConfigureAgents.ConfigureAgents_Footer_Submit)}
                </RoundedButton>
                <RoundedButton onClick={handleCancel} isOutlined={true} type='button' shrink>
                    {language.get(ConfigureAgents.ConfigureAgents_Footer_Cancel)}
                </RoundedButton>
            </div>
        </div>
    )
}
